<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="840"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Form ref="Forms" :model="Forms"  label-position="top">
                <Row :gutter="32">
                    <Col span="24">
                        <Card :bordered="false" dis-hover>
                            <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> 采购审批</template>
                            <FormItem label="">
                                <RadioGroup v-model="Forms.status" type="button" button-style="solid">
                                    <Radio :label="3">通过审批</Radio>
                                    <Radio :label="2">未通过审批</Radio>
                                </RadioGroup>
                            </FormItem>
                            <FormItem v-if="Forms.status === 2" label="驳回原因" prop="reject_remark" :rules="[{required: true, message: '请输入驳回原因', trigger: 'blur'}]">
                                <Input v-model="Forms.reject_remark" type="textarea" :rows="4" clearable placeholder="驳回原因"  />
                            </FormItem>
                        </Card>
                    </Col>
                </Row>
                <Row :gutter="32">
                    <Col span="24">
                        <Card :bordered="false" dis-hover>
                            <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> 采购信息</template>
                            <DescriptionList class="show-description-title" title="" :col="2"  layout="vertical">
                                <Description term="采购标题：">
                                    {{detail.title}}
                                </Description>
                                <Description term="采购产品：">
                                    <Tag v-for="(item,index) in detail.product_list" :key="index">{{item.name}}</Tag>
                                </Description>
                            </DescriptionList>
                            <DescriptionList class="show-description-title" title="" :col="2"  layout="vertical">
                                <Description term="项目名称：">
                                    <Tag>{{detail.project_name}}</Tag>
                                </Description>
                                <Description term="供应商：">
                                    <Tag>{{detail.company}}</Tag>
                                </Description>
                            </DescriptionList>
                            <DescriptionList class="show-description-title" title="" :col="2"  layout="vertical">
                                <Description term="采购金额：">
                                    <Tag color="blue">{{detail.buyer_money ?? '0.00'}}</Tag>
                                </Description>
                                <Description term="合同金额：">
                                    <Tag color="green">{{detail.pay_money ?? '0.00'}}</Tag>
                                </Description>
                                <Description term="合同凭证：">
                                    <Tag v-if="detail.contract" class="cursor" color="primary" @click="FileDownload(detail.contract)">点击下载项目资料</Tag>
                                    <small v-else>未上传</small>
                                </Description>
                                <Description term="负责人：">
                                    {{detail.head_name}}
                                </Description>

                            </DescriptionList>
                        </Card>
                        <Card :bordered="false" dis-hover>
                            <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> 项目说明</template>
                            <div class="textarea-wrap">{{detail.buyer_desc}}</div>
                        </Card>
                        <Card :bordered="false" dis-hover>
                            <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> 收款信息</template>
                            <DescriptionList class="show-description-title" title="" :col="2"  layout="vertical">
                                <Description term="收款账户：">
                                    {{detail.bank_account ?? '-'}}
                                </Description>
                                <Description term="账户实名：">
                                    {{detail.bank_real_name ?? '-'}}
                                </Description>
                                <Description term="收款银行：">
                                    {{detail.bank_name ?? '-'}}
                                </Description>
                                <Description term="开户地址：">
                                    {{detail.bank_address ?? '-'}}
                                </Description>
                            </DescriptionList>
                        </Card>

                    </Col>
                </Row>
            </Form>
            <div class="box-drawer-footer">
                <Button class="mr10" @click="FormReset()">取消</Button>
                <Button type="primary" :loading="$store.state.loading" @click="FormSubmit()">审批</Button>
            </div>
        </div>
    </Drawer>
</template>

<script>

import {examineBuyer, getBuyerDetail} from "@/apis/buyer";

export default {
    name: 'BuyerExamine',
    components: {
    },
    emits: ['trueHandler'],
    data () {
        return {
            title : '采购审批',
            isBox : false,
            detail: [],
            site_url : this.$siteApi,
            Forms : {
                buyer_id: '',
                reject_remark: '',
                status: 3
            }
        }
    },
    methods: {
        /**
         功能：
         time: 2025/12/19 18:12
         **/
        FileDownload(url){
            let that = this;
            if(url){
                //下载文件
                const fileUrl = that.site_url + url; // 文件的URL地址
                const parts = fileUrl.split('/');
                const fileName = parts[parts.length - 1];
                const link = document.createElement('a');
                link.href = fileUrl;
                link.target = '_blank';
                link.setAttribute('download', fileName);
                link.click();
            }else{
                that.$Message.error({ background: true,duration:3, content: '没有资料可下载'});
            }
        },
        /**
         功能：
         time: 2025/12/17 16:04
         **/
        GetDetail(buyer_id){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getBuyerDetail(buyer_id).then(e => {
                that.detail = e.data;
            })
        },

        /**
         功能：
         time: 2025/12/17 10:47
         **/
        show(buyer_id, title){
            this.isBox = true;
            this.title = title + ' - 采购审批';
            if(buyer_id){
                this.Forms.buyer_id = buyer_id;
                this.GetDetail(buyer_id);
            }
        },
        /**
         功能：
         time: 2025/12/20 09:24
         **/
        FormSubmit(){
            let that = this;
            this.$refs['Forms'].validate((valid) => {
                if (valid) {
                    that.$store.commit('SET_LOADING' , true);
                    examineBuyer(that.Forms).then( e =>{
                        that.$Message.success({ background: true,duration:3, content: e.msg });
                        that.FormReset();
                        that.$emit('trueHandler');
                    })
                }
            })
        },

        FormReset(){
            this.isBox = false;
            this.title = '采购审批';
            this.$refs['Forms'].resetFields();
            this.Forms.buyer_id = '';
            this.Forms.status = 3;
            this.detail = [];
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">

</style>
